import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import AppContext from "../../../AppContext";
import "./LoginEmpleado.css";
import imgLogIn from "../../../assets/images/logocolegio.png";

function LoginEmpleado() {
  const { loginEmpleado } = useContext(AuthEmpleadoContext);
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);

    try {
      const res = await axios.post(
        //cuando es local sacar el cst-servicios del url
        `${AppContext.baseApiUrl}/cst-servicios/empleados/login`,
        {
          mail: usuario,
          clave: clave,
        }
      );

      loginEmpleado(res.data);
      navigate("/DashboardEmpleados");
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-empleado-container">
      <div className="login-empleado-left">
        <img src={imgLogIn} alt="Colegio Santo Tomás" />
        <p className="link">¿Has olvidado la contraseña?</p>
      </div>

      <div className="login-empleado-card">
        <h2>ACCESO EMPLEADOS</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email institucional"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Contraseña"
            value={clave}
            onChange={(e) => setClave(e.target.value)}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Ingresando..." : "INGRESAR"}
          </button>

          {error && (
            <p className="error">
              Usuario o contraseña incorrectos
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default LoginEmpleado;
